import React from 'react';
import PropTypes from 'prop-types';

import buildRows from './build_rows';
import InfoTableTooltip from 'components/tooltip/info_table_tooltip';

export default function VoucherTooltip({ link, voucher }) {
  const tooltipRows = buildRows(voucher);

  return <InfoTableTooltip link={link} rows={tooltipRows} title={voucher.oneLineLabel} />;
}

VoucherTooltip.propTypes = {
  link: PropTypes.string,
  voucher: PropTypes.shape({
    listing: PropTypes.shape.isRequired,
    oneLineLabel: PropTypes.string.isRequired,
    property: PropTypes.shape.isRequired,
  }).isRequired,
};
